import TotalPriceForm from './total-price-form';

export default TotalPriceForm;
